import React from 'react'
import { format } from 'date-fns'
export const FormattedTime: React.SFC<{ datetime: Date; format?: string }> = ({
  datetime,
  format: dateFormat = 'K:mm aaaaa',
}) => <>{format(datetime, dateFormat)}</>
